import React, { useState, useRef, useEffect } from 'react';
import { Carousel } from 'components/Carousel';
import { Figure } from 'globalStyle';
import styled from 'styled-components';
import previewArrow from 'assets/previewArrowBlack.svg';
import nextArrow from 'assets/nextArrowBlack.svg';
import { useMediaQuery, useCategorizations } from 'hooks';
import CardCategory from './components/CardCategory';
import { Project, LoadingProject } from './components/Project';

const settings = {
  dots: false,
  autoplay: false,
  infinite: false,
  variableWidth: true,
  adaptiveHeight: true,
  slidesToScroll: 4,
};

const ListOfProjectComponent = ({
  isLoading,
  categorization,
  projects = [],
  showCardCategory,
  useCategorizationColors,
  from,
  isDefaultCategorization,
}) => {
  const isDesktop = useMediaQuery(1023);
  const isTablet = useMediaQuery(760);
  const carousel = useRef(null);
  const rootRef = useRef();
  const [maxCards, setMaxCards] = useState();
  const [showArrows, setShowArrows] = useState(true);
  const { defaultCategorization } = useCategorizations();
  useEffect(() => {
    if (rootRef?.current?.offsetWidth) {
      setMaxCards(parseInt((rootRef.current.offsetWidth + 20) / 298, 10));
    }
  }, [rootRef, rootRef.current, rootRef?.current?.offsetWidth]);
  useEffect(() => {
    if (maxCards) {
      if (
        maxCards < (showCardCategory ? projects.length + 1 : projects.length)
      ) {
        setShowArrows(true);
      } else {
        setShowArrows(false);
      }
    } else if (!isDesktop) {
      if (projects.length === 1 && !showCardCategory) {
        setShowArrows(false);
      } else {
        setShowArrows(true);
      }
    }
  }, [showCardCategory, maxCards, projects]);
  const next = () => carousel.current.slickNext();
  const prev = () => carousel.current.slickPrev();

  const settingsSlides = {
    ...settings,
    variableWidth: (isDesktop || isTablet) && true,
    slidesToScroll: isDesktop ? 2 : 1,
  };

  if (isLoading) {
    return <Loading ref={rootRef} />;
  }

  if (projects.length === 0) {
    return (
      <CardCategory
        isDesktop={isDesktop}
        name={categorization?.name}
        color={categorization?.color}
        formatUrl={categorization?.formatUrl}
        background={categorization?.background?.temporalResource}
        isMainCategorization={categorization === defaultCategorization}
      />
    );
  }

  return (
    <CarouselContainer isDesktop={isDesktop} isTablet={isTablet} ref={rootRef}>
      {showArrows && (
        <Figure
          onClick={prev}
          width="33px"
          height="45px"
          z={2}
          style={{
            position: 'absolute',
            left: isDesktop ? '-45px' : '-13px',
            bottom: '0',
            top: '50%',
            padding: '10px',
            cursor: 'pointer',
          }}
        >
          <img src={previewArrow} alt="anterior" />
        </Figure>
      )}
      <Carousel isCustomArrow refCarousel={carousel} {...settingsSlides}>
        {projects.map((project) => (
          <Project
            isDefaultCategorization={isDefaultCategorization}
            from={from}
            project={project}
            key={project.projectId}
            useCategorizationColors={useCategorizationColors}
            color={
              categorization?.id !== defaultCategorization?.id
              && categorization?.color
            }
          />
        ))}
        {showCardCategory && (
          <CardCategory
            isDesktop={isDesktop}
            name={categorization?.name}
            color={categorization?.color}
            formatUrl={categorization?.formatUrl}
            background={categorization?.background?.temporalResource}
            isMainCategorization={categorization === defaultCategorization}
          />
        )}
      </Carousel>
      {showArrows && (
        <Figure
          onClick={next}
          width="33px"
          height="45px"
          style={{
            cursor: 'pointer',
            position: 'absolute',
            right: isDesktop ? '-45px' : '-13px',
            bottom: '0',
            top: '50%',
            padding: '10px',
          }}
        >
          <img src={nextArrow} alt="siguiente" />
        </Figure>
      )}
    </CarouselContainer>
  );
};

const Loading = ({ ref }) => {
  const isDesktop = useMediaQuery(1023);
  const isTablet = useMediaQuery(760);
  const settingsSlides = {
    ...settings,
    variableWidth: (isDesktop || isTablet) && true,
    slidesToScroll: isDesktop ? 4 : 1,
  };
  return (
    <CarouselContainer ref={ref}>
      <Carousel {...settingsSlides} isCustomArrow>
        {[...new Array(4).keys()].map((index) => (
          <LoadingProject key={index} />
        ))}
      </Carousel>
    </CarouselContainer>
  );
};

export const CarouselContainer = styled.div`
  position: relative;
  .slick-slide {
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin-right: ${({ isDesktop, isTablet }) => (isDesktop || isTablet) && '20px'};
  }

  .slick-list > div {
    overflow: hidden;
  }
  .slick-track {
    margin: 0;
  }
  .slick-arrow {
    display: none !important;
  }
`;

export const ListOfProject = React.memo(ListOfProjectComponent);
